import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu-perfil',
  templateUrl: './menu-perfil.component.html',
  styleUrls: ['./menu-perfil.component.css']
})
export class MenuPerfilComponent implements OnInit {

  /*Opciones Menu*/
  public info: boolean = true; //Controla si se muestra el componente registro-usuarios
  public docs: boolean = false; //Controla si se muestra el componente registro-docsarch

  constructor(private router: Router) { }

  ngOnInit() {
  }

  ActualizaView(opcion: string){
    /*Refresca los componentes que se deben mostrar al usuario*/
    if (opcion === 'info') {
      this.info = true;
      this.docs = false;
    }

    if (opcion === 'docs') {
      this.info = false;
      this.docs = true;
    }

  }

}
